export enum LocalSessionKey {
  PLATFORM = 'loginSessionPreference'
}

export const getLocalSessionItem = (key: LocalSessionKey) => {
  return localStorage.getItem(key)
}

export const setLocalSessionItem = (key: LocalSessionKey, value: string) => {
  localStorage.setItem(key, value)
}
